import { useState } from 'react';
import { faqData } from '@/mocks/siteData';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="w-full bg-background-100 py-16" aria-labelledby="faq-title">
      <div className="max-w-[800px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 id="faq-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于亚洲视频精选平台，你想知道的一切</p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl border border-background-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                aria-expanded={openIdx === idx}
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">{item.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIdx === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIdx === idx ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-6 text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}